/** globals Knitiv */

export default class AccountInfosController {
	/* @ngInject */
	/**
	 * @param {Knitiv.RootScope} $rootScope
	 * @param {any} chatService
	 */
	constructor(
		$rootScope,
		chatService,
	) {
		this.api = $rootScope.context?.url;
		this.chat = chatService;
		this.context = $rootScope.context;
		this.appConfig = $rootScope.appConfig;
	}
}
